import React from 'react'
import './footer.css'
import {AiFillLinkedin} from 'react-icons/ai'
import {AiFillGithub} from 'react-icons/ai'
import {AiFillFacebook} from 'react-icons/ai'
import {AiFillTwitterSquare} from 'react-icons/ai'
import {BsInstagram} from 'react-icons/bs'


function footer() {
  return (
    <footer>
      <a href="#" className='footer__logo'>NikoBoykin</a>

      <ul className='permalinks'>
        <li><a href="#">Home</a></li>
        <li><a href="#about">About</a></li>
        <li><a href="#experience">Skills</a></li>
        <li><a href="#portfolio">Portfolio</a></li>
        <li><a href="#contact">Contact</a></li>
      </ul>


      <div className='footer__socials'>
        <a href="https://www.linkedin.com/in/niko-boykin-a46a3a241/" target="_blank"><AiFillLinkedin/></a>
        <a href="https://github.com/Nikoboykin" target="_blank"><AiFillGithub/></a>
        <a href="https://www.facebook.com/" target="_blank"><AiFillFacebook/></a>
        <a href="https://twitter.com/?lang=en" target="_blank"><AiFillTwitterSquare/></a>
        <a href="https://www.instagram.com/" target="_blank"><BsInstagram/></a>
      </div>








    </footer>
  )
}

export default footer